import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Check, Loader2, Sparkles } from "lucide-react";
import { startCheckout } from "../lib/razorpay";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const perks = [
  "Submit unlimited spots to dilli.wiki",
  "A “Supporter” badge on your account",
  "Early access to new curated OG Lists",
];

const UpgradeDialog = ({ open, onOpenChange, onSuccess }) => {
  const { setPremium } = useAuth();
  const [busy, setBusy] = useState(false);

  const pay = async () => {
    setBusy(true);
    const res = await startCheckout();
    setBusy(false);
    if (res.ok) {
      setPremium(res.user);
      toast.success("you're premium now — welcome, supporter!");
      onOpenChange(false);
      onSuccess && onSuccess();
    } else if (res.reason === "not_configured") {
      toast.error("payments aren't switched on yet. add your razorpay keys to go live.");
    } else if (res.reason === "already_premium") {
      toast("you already have premium access.");
      onOpenChange(false);
    } else if (res.reason === "dismissed") {
      // user closed checkout — stay quiet
    } else {
      toast.error("payment could not be completed. please try again.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <div className="mb-1 flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-100">
              <Sparkles className="h-4 w-4 text-amber-600" />
            </span>
            <DialogTitle>Go Premium</DialogTitle>
          </div>
          <DialogDescription>
            a one-time ₹99 unlocks the good stuff and supports dilli.wiki.
          </DialogDescription>
        </DialogHeader>

        <div className="my-2 rounded-xl border border-neutral-200 bg-[#faf8f4] p-4">
          <div className="flex items-baseline gap-1">
            <span className="text-3xl font-extrabold text-neutral-900">₹99</span>
            <span className="text-sm text-neutral-500">one-time</span>
          </div>
          <ul className="mt-3 grid gap-2">
            {perks.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-neutral-700">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <Button onClick={pay} disabled={busy}
          className="h-11 w-full rounded-full bg-neutral-900 text-white hover:bg-neutral-800">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
          Pay ₹99 with Razorpay
        </Button>
        <p className="text-center text-xs text-neutral-400">secure checkout · powered by Razorpay</p>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeDialog;
